<template>
    <div>
        <a-card type="inner" size="small">
            <a-skeleton :loading="preload" active>
                <a-form-model :form="form" :model="formData" labelAlign="left">
                    <a-divider dashed orientation="left">Form Pelatihan</a-divider>

                    <a-row type="flex" :gutter="[48, 8]">
                        <a-col :span="12">
                            <a-form-model-item label="Judul Pelatihan">
                                <a-input v-model="formData.title"/>
                            </a-form-model-item>

                            <a-form-model-item label="Deskripsi">
                                <a-textarea v-model="formData.description"/>
                            </a-form-model-item>

                            <a-form-model-item label="Tanggal Mulai">
                                <a-date-picker
                                    v-model="formData.date_start"
                                    @change="onStartDateChange"
                                    :format="'YYYY-MM-DD'"
                                    type="date"
                                    placeholder="Pick a date"
                                />
                            </a-form-model-item>

                            <a-form-model-item label="Tanggal Berakhir">
                                <a-date-picker
                                    v-model="formData.date_end"
                                    @change="onEndDateChange"
                                    :format="'YYYY-MM-DD'"
                                    type="date"
                                    placeholder="Pick a date"
                                />
                            </a-form-model-item>

                            <a-form-model-item label="Domain">
                                <a-input v-model="formData.domain"/>
                            </a-form-model-item>

                            <a-form-model-item label="Lokasi">
                                <a-input v-model="formData.location"/>
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-model-item label="Modul">
                                <a-row v-for="d in modules" :key="d.value">
                                    <a-col>
                                        <a-checkbox :value="d.value" @change="(e) => onChange(e, d.value)" 
                                            :default-checked="d.value == 'classical'"
                                            :disabled="d.value == 'classical'">
                                            {{ d.label }}
                                        </a-checkbox>

                                        <a-row type="flex" :gutter="[8, 8]">
                                            <template v-if="formData['checked_' + d.value] == true">
                                                <a-col :span="8">
                                                    <div>
                                                        Tanggal Mulai: <br/>
                                                        <a-date-picker
                                                            v-model="formData['date_start_' + d.value]"
                                                            @change="(date, dateString) => onKpiStartDateChange(date, dateString, d.value)"
                                                            :format="'YYYY-MM-DD'"
                                                            type="date"
                                                            placeholder="Pick a date"
                                                        />
                                                    </div>
                                                </a-col>

                                                <a-col :span="8">
                                                    <div>
                                                        Tanggal Berakhir: <br/>
                                                        <a-date-picker
                                                            v-model="formData['date_end_' + d.value]"
                                                            @change="(date, dateString) => onKpiEndDateChange(date, dateString, d.value)"
                                                            :format="'YYYY-MM-DD'"
                                                            type="date"
                                                            placeholder="Pick a date"
                                                        />
                                                    </div>
                                                </a-col>

                                                <a-col :span="8">
                                                    <div>
                                                        Bobot: <br/>
                                                        <a-input-number v-model="formData['weight_' + d.value]" :min="0" :max="100" />
                                                    </div>
                                                </a-col>
                                            </template>
                                        </a-row>
                                            
                                    </a-col>
                                </a-row>
                            </a-form-model-item>

                            <a-form-model-item
                                v-for="(kelas, index) in formData.classes"
                                :key="kelas.key"
                                :label="index === 0 ? 'Nama Kelas Klasikal' : ''"
                                :prop="'classes.' + index + '.value'"
                            >

                                <a-input 
                                    v-model="formData.classes[index].name"
                                    style="width: 30%; margin-right: 8px" />

                                <a-icon
                                    v-if="formData.classes.length > 1"
                                    class="dynamic-delete-button"
                                    type="minus-circle-o"
                                    :disabled="formData.classes.length === 1"
                                    @click="removeClass(kelas)"
                                />
                            </a-form-model-item>

                            <a-form-model-item>
                                <a-button type="dashed" style="width: 30%" @click="addClass">
                                    <a-icon type="plus" /> Tambah Kelas Klasikal
                                </a-button>
                            </a-form-model-item>
                        </a-col>
                    </a-row>

                    <a-form-model-item>
                        <a-row type="flex" justify="center" align="top">
                            <a-col>
                                <a-space>
                                    <a-button
                                        type="primary"
                                        html-type="submit"
                                        :loading="processing"
                                        :disabled="processing"
                                        @click="handleSubmit"
                                        >Submit</a-button>
                                    <a-button
                                        @click="handleClose"
                                        :loading="processing"
                                        :disabled="processing"
                                        >Tutup</a-button>
                                </a-space>
                            </a-col>
                        </a-row>
                    </a-form-model-item>
                </a-form-model>
            </a-skeleton>
        </a-card>
    </div>
</template>

<script>
const modules = [
    { label: 'Klasikal', value: 'classical' },
    { label: 'Performance', value: 'performance' },
    { label: 'Makalah', value: 'paper' },
    { label: 'Project Management', value: 'project' },
    { label: 'Evaluasi', value: 'evaluation' },
]

export default {
    props: {
        hash: {
            type: String,
            default: ''
        },
        bank: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            modules,
            labelCol: { span: 5 },
            wrapperCol: { span: 10 },
            form: this.$form.createForm(this),
            preload: false,
            processing: false,
            formData: {
                bank_id: this.bank,
                checked_classical: false,
                checked_performance: false,
                checked_paper: false,
                checked_project: false,
                checked_evaluation: false,
                modules: [],
                classes: [
                    {
                        name: '',
                    }
                ],
            },
            formItemLayoutWithOutLabel: {
                wrapperCol: {
                xs: { span: 24, offset: 0 },
                sm: { span: 20, offset: 4 },
                },
            },
        }
    },
    created() {
        if (this.editing) {
            this.preload = true
            this.getItem()
        }

        this.formData['checked_classical'] = true
    },
    computed: {
        editing() {
            return this.hash !== "";
        }
    },
    methods: {
        getItem() {
            this.$http
                .get(this.routeUri("api.trainings.show", {training: this.hash}))
                .then(response => this.formData = response.data)
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.preload = false))
        },
        handleSubmit(e) {
            e.preventDefault(e);

            this.processing = true;

            let promise;

            this.formData.modules = []

            if(this.formData.checked_classical == true){
                this.formData.modules.push(
                    {
                        module: 'classical',
                        date_start: this.formData.date_start_classical,
                        date_end: this.formData.date_end_classical,
                        weight: this.formData.weight_classical,
                    }
                )
            }

            if(this.formData.checked_performance == true){
                this.formData.modules.push(
                    {
                        module: 'performance',
                        date_start: this.formData.date_start_performance,
                        date_end: this.formData.date_end_performance,
                        weight: this.formData.weight_performance,
                    }
                )
            }

            if(this.formData.checked_paper == true){
                this.formData.modules.push(
                    {
                        module: 'paper',
                        date_start: this.formData.date_start_paper,
                        date_end: this.formData.date_end_paper,
                        weight: this.formData.weight_paper,
                    }
                )
            }

            if(this.formData.checked_project == true){
                this.formData.modules.push(
                    {
                        module: 'project',
                        date_start: this.formData.date_start_project,
                        date_end: this.formData.date_end_project,
                        weight: this.formData.weight_project,
                    }
                )
            }

            if(this.formData.checked_evaluation == true){
                this.formData.modules.push(
                    {
                        module: 'evaluation',
                        date_start: this.formData.date_start_evaluation,
                        date_end: this.formData.date_end_evaluation,
                        weight: this.formData.weight_evaluation,
                    }
                )
            }

            if(!this.editing){
                promise = this.$http.post(
                    this.routeUri("api.trainings.store"),
                    this.formData
                );
            }else{
                promise = this.$http.put(
                    this.routeUri("api.trainings.update", {training: this.hash}),
                    this.formData
                );
            }

            promise
                .then(response =>
                    this.handleSuccessResponse(response.data)
                )
                .catch(error =>
                    this.handleResponseError(error.response.data)
                )
                .finally(() => (this.processing = false));
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!";

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage;
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });

            this.$emit("handleClose", true);
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
        handleClose() {
            this.$emit("handleClose", false);
        },
        onStartDateChange(date, dateString) {
            this.formData.date_start = dateString
        },
        onKpiStartDateChange(date, dateString, kpi) {
            this.formData['date_start_' + kpi] = dateString
        },
        onEndDateChange(date, dateString) {
            this.formData.date_end = dateString
        },
        onKpiEndDateChange(date, dateString, kpi) {
            this.formData['date_end_' + kpi] = dateString
        },
        onChange(e, kpi) {
            this.formData['checked_' + kpi] = e.target.checked

            if(e.target.checked == false) {
                let index = this.formData.modules.findIndex(x => x.module === kpi);

                this.formData.modules.splice(index, 1)
            }
        },
        removeClass(item) {
            let index = this.formData.classes.indexOf(item);
            if (index !== -1) {
                this.formData.classes.splice(index, 1);
            }
        },
        addClass() {
            this.formData.classes.push({
                name: '',
            });
        },
    }
}
</script>